/**
 * "Ver como": a aba aberta pelo admin carrega o token em `sessionStorage` (só esta aba) e cada
 * chamada leva `x-ver-como`. A organização escolhida aqui também fica só na aba — trocar de
 * organização não pode gravar nada na conta da pessoa.
 */
const TOKEN = "bd-ver-como";
const ORG = "bd-ver-como-org";
export const PAGINA_ENCERRADA = "/ver-como/encerrado";

function ler(chave: string) {
  try {
    return sessionStorage.getItem(chave);
  } catch {
    return null;
  }
}

export const tokenDoVerComo = () => ler(TOKEN);
export const emVerComo = () => !!ler(TOKEN);
export const orgDoVerComo = () => ler(ORG);

export function definirOrgDoVerComo(organizationId: string) {
  sessionStorage.setItem(ORG, organizationId);
}

export function sairDoVerComo() {
  sessionStorage.removeItem(TOKEN);
  sessionStorage.removeItem(ORG);
}

/** Roda antes do React: `/ver-como#<token>` guarda o token e segue pro Início sem o token na URL. */
export function capturarTokenDoVerComo() {
  if (window.location.pathname !== "/ver-como" || window.location.hash.length < 2) return;
  sessionStorage.setItem(TOKEN, window.location.hash.slice(1));
  sessionStorage.removeItem(ORG);
  window.history.replaceState(null, "", "/inicio");
}

/** Sessão vencida, revogada ou encerrada: limpa a aba e mostra o aviso (nunca cai na conta do admin). */
export function tratarFimDoVerComo(erro: unknown) {
  if (!emVerComo() || (erro as { message?: string })?.message !== "VER_COMO_ENCERRADO") return;
  sairDoVerComo();
  window.location.replace(PAGINA_ENCERRADA);
}
